import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ProductModal } from "./ProductModal";
// import { ProductCard } from "./ProductCard";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import useIsMobile from '../hooks/useIsMobile';
import { Box } from '@mui/material';
import { useIsMedium } from "hooks/useIsMobile";
import { ProductCard } from "./ProductCard/ProductCard";

const Medicaments = ({ allMedicaments, selectedProduct, setSelectedProduct, loading, setShowPartnerDialog }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [categoryStartIndex, setCategoryStartIndex] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const isMedium = useIsMedium();

  const addMedicament = (medicament) => {
    dispatch(addCart(medicament));
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
    setShowPopup(false);
  };

  const handleOpenModal = (medicament) => {
    setSelectedProduct(medicament);
    setShowPopup(true);
  };

  const isAuthenticated = () => {
    return !!localStorage.getItem("userEmail");
  };

  const handleAddToCart = (med) => {
    if (isAuthenticated()) {
      setShowPopup(true);
    } else {
      window.location.href = "/login";
    }
  };

  const handleScrollLeft = (categoryId, maxProducts) => {
    setCategoryStartIndex(prev => ({
      ...prev,
      [categoryId]: Math.max(0, (prev[categoryId] || 0) - 1)
    }));
  };

  const handleScrollRight = (categoryId, maxProducts) => {
    const itemsToShow = isMobile ? 2 : isMedium ? 3 : 4;
    setCategoryStartIndex(prev => ({
      ...prev,
      [categoryId]: Math.min(maxProducts - itemsToShow, (prev[categoryId] || 0) + 1)
    }));
  };

  const Loading = () => {
    return (
      <>
        <div className="col-12 py-5 text-center">
          <Skeleton height={40} width={560} />
        </div>
        <div className="col-md-4 col-sm-6 col-xs-8 col-12 mb-4">
          <Skeleton height={592} />
        </div>
      </>
    );
  };

  const ShowMedicaments = () => {
    const categories = [
      { id: 1, title: "Sport Wellness" },
      { id: 2, title: "Beauty & Cosmetics" },
      { id: 3, title: "OTC Medicine" },
      { id: 4, title: "Special Offers" },
      { id: 5, title: "Vitamins" },
      { id: 6, title: "Skin Care" },
      { id: 7, title: "Women care" },
      { id: 8, title: "Hygiene care" },
      { id: 9, title: "Baby care" },
    ];

    if (!allMedicaments || allMedicaments.length === 0) {
      return <div>No medicaments available.</div>;
    }

    return (
      <>
        <div
          style={{ display: 'flex', flexDirection: 'column', gap: '80px', alignItems: 'stretch', width: '100%' }}
        >
          {categories.map((category) => {
            const productsInCategory = allMedicaments.filter(med => Number(med.category_id) === Number(category.id));
            if (productsInCategory.length === 0) return null;

            const itemsToShow = isMobile ? 2 : isMedium ? 3 : 4;
            const startIndex = categoryStartIndex[category.id] || 0;
            const canScrollLeft = startIndex > 0;
            const canScrollRight = startIndex < productsInCategory.length - itemsToShow;
            const visibleProducts = productsInCategory.slice(startIndex, startIndex + itemsToShow);

            return (
              <div key={category.id}
                style={{ position: 'relative', alignItems: 'flex-start', display: 'flex', flexDirection: 'column' }}>
                
                {/* Category Title with Simple Scroll Controls */}
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                  marginBottom: isMobile ? '16px' : '24px',
                  padding: isMobile ? '0 8px' : '0',
                }}>
                  <span
                    style={{
                      color: 'rgba(1, 6, 66, 1)',
                      fontSize: isMobile ? '18px' : '32px', 
                      textAlign: 'left',
                      fontFamily: 'Playfair Display',
                      fontWeight: 700,
                      lineHeight: isMobile ? '1.5' : '60px',
                      fontStretch: 'normal',
                      textDecoration: 'none',
                    }}
                  >
                    {category.title}
                  </span>

                  
                  {/* Simple Scroll Controls */}
<div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
  <span
    onClick={() => navigate('/listproduct/' + category.id)}
    style={{
      color: 'rgba(1, 6, 66, 1)',
      fontSize: isMobile ? '16px' : '20px',
      fontWeight: 600,
      fontFamily: 'Playfair Display',
      cursor: 'pointer',
      transition: 'color 0.3s ease, transform 0.2s ease',
    }}
    onMouseEnter={(e) => {
      e.target.style.color = '#C37559';
      e.target.style.transform = 'translateX(3px)';
    }}
    onMouseLeave={(e) => {
      e.target.style.color = 'rgba(1, 6, 66, 1)';
      e.target.style.transform = 'translateX(0)';
    }}
  >
    See all →
  </span>
</div>

                </div>

                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${itemsToShow}, 1fr)`,
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    gap: { xs: '12px', md: '3vw' },
                    width: '100%',
                    padding: { xs: '0 8px', md: '0' },
                  }}
                >
                  {visibleProducts.map((medicament) => (
                    <Box
                      key={medicament.id}
                      sx={{
                        flex: '0 0 auto',
                        width: { xs: '100%', sm: '180px', md: '200px', lg: '280px' },
                        cursor: 'pointer',
                      }}
                      onClick={() => handleOpenModal(medicament)}>
                      <ProductCard {...medicament} setShowPartnerDialog={setShowPartnerDialog} inStock={medicament.inStock === true || medicament.inStock === 'true'} />
                    </Box>
                  ))}
                </Box>

                {/* Commented out complex navigation buttons */}
                {/*
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: isMobile ? '15px' : '30px',
                    marginTop: '40px',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      marginTop: '20px',
                      width: '100%',
                    }}
                  >
                    <span
                      onClick={() => navigate('/listproduct/' + category.id)}
                      style={{
                        color: 'rgba(1, 6, 66, 1)',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: 500,
                        fontFamily: 'Manrope, sans-serif',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}
                    >
                      Explore all
                    </span>
                  </div>

                  // Left scroll button
                  {canScrollLeft ? (
                    <button
                      onClick={() => handleScrollLeft(category.id, productsInCategory.length)}
                      style={{
                        background:  '#C37559',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: isMobile ? '45px' : '55px',
                        height: isMobile ? '45px' : '55px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '18px' : '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 15px rgba(25, 140, 107, 0.3)',
                        transition: 'all 0.3s ease',
                        fontWeight: 'bold',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.1)';
                        e.target.style.boxShadow = '0 6px 20px rgba(25, 140, 107, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 4px 15px rgba(25, 140, 107, 0.3)';
                      }}
                    >
                      &#8249;
                    </button>
                  ) : (
                    <div style={{ width: isMobile ? '45px' : '55px' }}></div>
                  )}

                  // Explore All Button
                  <button
                    onClick={() => navigate('/listproduct/' + category.id)}
                    style={{
                      background: 'linear-gradient(135deg, #0E4736, #198C6B)',
                      color: 'white',
                      border: 'none',
                      borderRadius: isMobile ? '25px' : '30px',
                      padding: isMobile ? '12px 30px' : '15px 50px',
                      fontSize: isMobile ? '14px' : '18px',
                      fontWeight: '700',
                      fontFamily: 'Manrope, sans-serif',
                      cursor: 'pointer',
                      boxShadow: '0 6px 20px rgba(14, 71, 54, 0.3)',
                      transition: 'all 0.3s ease',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 8px 25px rgba(14, 71, 54, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 6px 20px rgba(14, 71, 54, 0.3)';
                    }}
                  >
                    <span style={{ position: 'relative', zIndex: 1 }}>
                      Explore All
                    </span>
                  </button>

                  // Right scroll button
                  {canScrollRight ? (
                    <button
                      onClick={() => handleScrollRight(category.id, productsInCategory.length)}
                      style={{
                        background: '#C37559',
                        color: 'white',
                        border: 'none',
                        borderRadius: '50%',
                        width: isMobile ? '45px' : '55px',
                        height: isMobile ? '45px' : '55px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '18px' : '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 15px rgba(25, 140, 107, 0.3)',
                        transition: 'all 0.3s ease',
                        fontWeight: 'bold',
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.1)';
                        e.target.style.boxShadow = '0 6px 20px rgba(25, 140, 107, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 4px 15px rgba(25, 140, 107, 0.3)';
                      }}
                    >
                      &#8250;
                    </button>
                  ) : (
                    <div style={{ width: isMobile ? '45px' : '55px' }}></div>
                  )}
                </div>
                */}
              </div>
            );
          })}
        </div>

        {selectedProduct && showPopup && (
          <ProductModal
            setShowPartnerDialog={setShowPartnerDialog}
            onClose={handleCloseModal}
            onAddToCart={handleAddToCart}
            imageData={selectedProduct.imageData}
            name={selectedProduct.name}
            subtitle={selectedProduct.variant}
            description={selectedProduct.description || 'No description available'}
            price={selectedProduct.price}
            id={selectedProduct.id}
            partner_id={selectedProduct.partner_info?.id || selectedProduct.partner_id}
            partner_info={selectedProduct.partner_info}
            inStock={selectedProduct.inStock === true || selectedProduct.inStock === 'true'}
          />
        )}
      </>
    );
  };

  return (
    <>
      {/* Medicament list */}
      {loading ? <Loading /> : <ShowMedicaments />}
    </>
  );
};

export default Medicaments;